import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';
import { createTag } from './tags_api';
import Errors from 'components/form/errors';

export default function TaskTagForm({ onCancel, onSave }) {
  const [name, setName] = useState();
  const [errors, setErrors] = useState();

  const handleNameChange = e => setName(e.target.value);
  const createNewTag = () => {
    createTag({ contactsTaskTag: { name } })
      .then(taskTag => onSave(taskTag))
      .catch(errors => setErrors(errors));
  };

  return (
    <div className="form-group">
      <Errors errors={errors}/>
      <label className="control-label">Name</label>
      <input
        className="form-control"
        name="name"
        placeholder="Enter a new name"
        type="text"
        onChange={handleNameChange}
      />
      <div className="mt-4">
        <button
          className="btn btn-cancel"
          name="cancel-button"
          onClick={() => onCancel()}
        >
          Cancel
        </button>
        <button
          className="btn btn-save ml-3"
          disabled={isBlank(name)}
          name="create-tag-button"
          onClick={createNewTag}
        >
          Create Tag
        </button>
      </div>
    </div>
  );
}

TaskTagForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
